import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const ArrowUpIcon = ({
	width = 14,
	height = 14,
  strokeColor='var(--blue)',
}: IIconProps) => {
	return (
		<svg width={width} height={height} viewBox="0 0 14 10" fill="none">
			<path d="M7 0.5L13.9282 8.75L0.0717969 8.75L7 0.5Z" fill={strokeColor} />
		</svg>
	)
}

export default ArrowUpIcon
